module.exports = __webpack_public_path__ + "static/media/04.83adc2ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/project/verdindung/04.png
// module id = 120
// module chunks = 0